module.exports = __webpack_public_path__ + "static/media/danger.301790b7.svg";